import { APP_ID, APP_ID_PRODUCTION, FACEBOOK_API_VERSION } from "../constants";
import { useStore } from "../store";

// Injects the Facebook SDK into the page
const injectFbSDKScript = () => {
  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");
};

export const useInitFbSDK = () => {
  const { isInitialized, setIsInitialized } = useStore();

  // Initializes the SDK once the script has been loaded
  window.fbAsyncInit = function () {
    window.FB.init({
      // // appId: "379716970101549", // dev
      // appId: "694959341044795", // production
      appId: APP_ID,
      cookie: true,
      xfbml: true,
      version: FACEBOOK_API_VERSION,
    });

    window.FB.AppEvents.logPageView();
    // setIsInitialized(true);
  };

  injectFbSDKScript();

  return isInitialized
};
